<template>
    <div id="enter-name"> 
        <enter-name-gender v-show="!displayNameText" v-on:showNameText = "onShowNameText" v-on:cancel="onCancel"></enter-name-gender>
        <enter-name-text v-if="displayNameText" ref="nameText" v-on:confirmableChanged = "onConfirmableTitleChanged"></enter-name-text>
        <primary-buttons v-on:cancel="onCancel" v-on:confirm="onConfirm" :confirmable="confirmable()"></primary-buttons>
    </div>
</template>

<script type="ts">
import { Module, VuexModule, getModule } from 'vuex-module-decorators'
import { Component, Vue, Prop } from 'vue-property-decorator'
import PrimaryButtons from '@/components/common/PrimaryButtons.vue'
import { AppModule } from '@/store/modules/app'
import { TreasureBookModule } from '@/store/modules/treasureBook'
import EnterNameText from "@/components/products/schatzbuch/steps/EnterNameText.vue"
import EnterNameGender from "@/components/products/schatzbuch/steps/EnterNameGender.vue"

export default {
    name: 'enter-name',
    data: function() {
        return {
            displayNameText: false,
            confirmableTitle: false,
            oldChildgender: TreasureBookModule.childGender
        }
    },
    methods: {
        confirmable: function() {
            if(this.displayNameText) {
                return this.confirmableTitle
            }
            return false
        },
        onCancel: function() {
            if(this.displayNameText) {
                this.$refs.nameText.cancel()
                this.displayNameText = false
            } else {
                TreasureBookModule.SetChildGender(this.oldChildgender)
                this.$emit('cancel')
            }
        },
        onConfirm: function() {
            if(this.displayNameText && this.confirmableTitle) {
                this.$emit('confirm')
            }
        },
        onConfirmableTitleChanged: function(confirmable) {
            this.confirmableTitle = confirmable
        },
        goToMenu: function() {
            if(this.confirmableTitle) {
                this.onConfirm()
            }else {
                this.onCancel()
            }
        },
        onShowNameText: function() {
            this.displayNameText = true;
        }
    },
    components: {
        EnterNameGender,
        EnterNameText,
        PrimaryButtons
    }
}
</script>


<style lang="scss">
</style>